<div class="min-h-screen destiny-bg-shell" [class.destiny-bg-still]="textView.enabled()">
  <div class="iron-temple-fire" aria-hidden="true"></div>
  <div class="siva-projection-sparkles" aria-hidden="true"></div>
  <header class="glass-effect border-b border-destiny-border-primary/30 relative z-10">
    <div class="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-3">
          <div class="w-10 h-10 flex items-center justify-center shrink-0">
            <img src="assets/icons/destiny/destiny.svg" alt="" class="w-9 h-9 drop-shadow-glow" aria-hidden="true" />
          </div>
          <div>
            <h1 class="text-3xl font-bold font-d2-headline text-gradient tracking-tight">{{ title }}</h1>
            <p class="text-sm text-destiny-text-secondary">Track your Destiny 1 &amp; 2 activity history</p>
          </div>
        </div>
        <button type="button"
                class="text-view-toggle"
                [class.text-view-toggle--on]="textView.enabled()"
                [attr.aria-pressed]="textView.enabled()"
                (click)="textView.toggle()">
          Text view
        </button>
      </div>
    </div>
  </header>

  <main class="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-4 animate-fade-in relative z-10">
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
      <div class="absolute -top-40 -right-40 w-80 h-80 bg-[var(--destiny-flame)]/8 rounded-full blur-3xl"></div>
      <div class="absolute bottom-0 left-1/4 w-96 h-48 bg-[var(--destiny-ember)]/10 rounded-full blur-3xl"></div>
      <div class="absolute top-40 -left-40 w-96 h-96 bg-[var(--destiny-iron)]/8 rounded-full blur-3xl"></div>
    </div>

    <app-browser-compatibility-warning></app-browser-compatibility-warning>

    <div class="relative">
      <app-player-search></app-player-search>
    </div>
  </main>

  <app-performance-monitor></app-performance-monitor>
</div>
